<ng-container *ngIf="data$ | async">
  <ng-container *ngIf="showLabel">
    <miq-record-detail-label [column]="config"> </miq-record-detail-label>
  </ng-container>
  <div class="flex-grid">
    <miqControlWithRuleEngine
      class="col"
      [formCtrl]="form"
      [dataCtrl]="control"
      [hidden]="config.hidden"
      [(config)]="config"
    >
      <!-- DEFAULT SINGLE INPUT -->
      <miq-input-control [formControl]="control" [column]="config"> </miq-input-control>
    </miqControlWithRuleEngine>

    <!-- RELATED INPUT -->
    <ng-container
      *ngTemplateOutlet="
        relatedColumn;
        context: { columns: config | relatedConfigs: config.componentConfig?.targetRelation }
      "
    ></ng-container>
    <ng-template #relatedColumn let-columns="columns">
      <ng-container *ngFor="let col of columns; let i = index">
        <miqControlWithRuleEngine
          class="col"
          [formCtrl]="form"
          [dataCtrl]="relatedControls[columns[i].columnId]"
          [hidden]="columns[i].hidden"
          [(config)]="columns[i]"
        >
          <miq-input-control
            [id]="'columns' + columns[i]?.columnId"
            [formControl]="relatedControls[columns[i].columnId]"
            [(column)]="columns[i]"
          >
          </miq-input-control>
        </miqControlWithRuleEngine>
      </ng-container>
    </ng-template>

    <!-- render input icons if configured -->
    <span
      *ngFor="let inputIcon of config.inputIcons"
      [miqInputIconHandler]="inputIcon"
      [control]="control"
      class="extra-icons"
    >
    </span>
  </div>
</ng-container>
